(function () {
    "use strict";

    const directiveName = "habilFileDownload";
    const options = { noLoader: "NoLoader" };

    angular.module("app").directive(directiveName, DownloadFileDirective);

    DownloadFileDirective.$inject = ["downloadService", "loadingIndicatorService", "base64Service"];
    function DownloadFileDirective(downloadService, loadingIndicatorService, base64Service) {
        return {
            restrict: "A",
            scope: {
                attachment: "<habilFileDownload"
            },
            link: function (scope, elm, attrs) {
                // Do not register handler if no attachment is provided
                if (!scope.attachment)
                    return;

                elm.on("click", buildHandler(attrs, scope.attachment));
            }
        };

        function buildHandler(attributes, attachment) {

            const showLoader = !attributes.hasOwnProperty(directiveName + options.noLoader);

            return function () {
                // Save file if Content is already loaded
                if (attachment.Content) {
                    base64Service.SaveBase64File(attachment);
                    return;
                }

                if (showLoader)
                    loadingIndicatorService.SetLoadingState(true);

                downloadService.DownloadAttachment(attachment, showLoader ? () => loadingIndicatorService.SetLoadingState(false) : angular.noop);
            };
        }
    }
})();